<template>
    <span class="icon">
        <i class="fas fa-spinner fa-spin"></i>
    </span>
</template>

<script>
    export default {
        name: "inline-spinner",
    };
</script>

<style scoped></style>
